//Node Modules
import { useRecoilValueLoadable } from "recoil";
import { useTranslation } from "react-i18next";

//Pages

//BinaryForge Components
import { AlarmGroupTable } from "./";
import { DatatableSkeleton } from "../../helpers/skeleton";
import { Note } from "../../helpers";

//3rd Party Components

//Atoms
import { alarmGroupListSelector } from "../../../atoms/alarm";

//Helpers
import { useSensorActuatorLabels } from "../../../config/device";

//Other

const getErrorMessage = (err) => {
	if (Array.isArray(err?.errors) && err.errors.length > 0) {
		return err.errors
			.map((e) => e?.message)
			.filter(Boolean)
			.join(", ");
	}
	if (typeof err?.message === "string" && err.message.length > 0) {
		return err.message;
	}
	if (typeof err === "string") {
		return err;
	}

	try {
		return JSON.stringify(err);
	} catch {
		return "Unknown error";
	}
};

const AlarmGroupLoader = () => {
	//Recoil
	const { t } = useTranslation();
	const { state, contents } = useRecoilValueLoadable(alarmGroupListSelector);

	switch (state) {
		case "hasError":
			return (
				<Note
					messageKey={`Error: ${getErrorMessage(contents)}`}
					icon="pi-exclamation-circle fontColour-error"
				/>
			);
		case "loading":
			return (
				<DatatableSkeleton
					columns={[
						t("alarm.group.common.name"),
						t(useSensorActuatorLabels ? "alarm.group.common.sensorCount" : "alarm.group.common.inputCount"),
						t(useSensorActuatorLabels ? "alarm.group.common.actuatorCount" : "alarm.group.common.outputCount"),
						// "Local Config" (espComplete) column hidden pending completion of the ESP-NOW peer-config feature (issue #43)
						// t("alarm.group.common.espComplete"),
					]}
				/>
			);
		case "hasValue":
			return <AlarmGroupTable alarmGroupData={contents} />;
		default:
			return null;
	}
};

export default AlarmGroupLoader;
